import intl from 'react-intl-universal'

export default [
  /* dependencies */
  'settingsService',
  'toastr',
  orgSettingsJsonController,
]

function orgSettingsJsonController(settingsService, toastr) {
  this.json = ''
  this.group = ''

  const loadGroup = (group) => {
    return settingsService.fetchCompanySettings('org').then((resp) => {
      return resp.data[group] || {}
    })
  }

  const saveGroup = (group, obj) => {
    return settingsService.fetchCompanySettings('org').then((resp) => {
      var orgObj = resp.data
      orgObj[group] = obj
      return settingsService.saveCompanySettings('org', orgObj)
    })
  }

  this.save = () => {
    let obj
    try {
      obj = JSON.parse(this.json)
    } catch (e) {
      toastr.error(intl.get('orgSettingsJson.save.error'))
      return
    }
    saveGroup(this.group, obj)
  }

  this.load = () => {
    loadGroup(this.group).then((data) => {
      this.json = JSON.stringify(data)
    })
  }

  console.log(settingsService)
  this.$onInit = () => {}
}
